// Scripts
import './main';

// Style
import '../sass/main.scss';

